module.exports = __webpack_public_path__ + "img/door.be5030ca.webp";